var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.user.isAdmin
      ? _c("div", [_c("resource-admin-table")], 1)
      : _c("div", [_c("resource-user-dashboard")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }